// Get Performance Snapshot
export const GET_PERFORMANCE_SNAPSHOT_REQUEST = 'GET_PERFORMANCE_SNAPSHOT_REQUEST';
export const GET_PERFORMANCE_SNAPSHOT_DONE = 'GET_PERFORMANCE_SNAPSHOT_DONE';
export const GET_PERFORMANCE_SNAPSHOT_FAILED = 'GET_PERFORMANCE_SNAPSHOT_FAILED';
export const GET_PERFORMANCE_SNAPSHOT_RESET = 'GET_PERFORMANCE_SNAPSHOT_RESET';